import React from 'react';
import { LoaderComponent } from './style';
import Loader from '.';

const ModalOpenLoader = ({ loadExportInfo }) => {
  return (
    <>
      <LoaderComponent>
        {loadExportInfo ? (
          <div style={{ background: 'white', padding: 30, boxShadow: '#717171 0px 0px 7px 0px' }}>
            <div style={{ fontWeight: 'bold', fontSize: 16 }}>Exporting User Data</div>
            <Loader loadExportInfo={loadExportInfo} />
          </div>
        ) : (
          <Loader />
        )}
      </LoaderComponent>
    </>
  );
};

export default ModalOpenLoader;
